import { mergeDeepRight } from "rambdax";
/**
 * Provides safe defaults for Launch Darkly attributes that can be overridden
 * with passed attributes.
 *
 * @public
 */ const makeAttributes = (config)=>mergeDeepRight({
        /**
     * Specifies the application fetching flags
     */ customAttributes: {},
        privateAttributes: []
    })(config.attributes ?? {});
export default makeAttributes;
